import {Component, OnInit, ViewChild} from '@angular/core';
import {PortfolioService} from '../portfolio.service';
import {AddFileComponent} from '../../../shared-components/controls/add-file/add-file.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import {Portfolio} from '../portfolio.model';
import {UserService} from '../../../shared-components/user/user.service';
import {StudentService} from '../../../shared-components/student/student.service';
import {YearService} from '../../../shared-components/year/year.service';

@Component({
  selector: 'app-add-portfolio-modal',
  templateUrl: './add-portfolio-modal.component.html',
  styleUrls: ['./add-portfolio-modal.component.css']
})
export class AddPortfolioModalComponent implements OnInit {
  @ViewChild(AddFileComponent, { static: true }) addFile;
  addDocumentForm: FormGroup;
  category: number;
  fileError = false;
  description: string;
  portfolioCategories: any[];
  fileCategoryErrorMessage = 'Required Field';
  fileDescriptionErrorMessage = 'Required Field';

  constructor(private yearService: YearService, private portfolioService: PortfolioService, private userService: UserService, private studentService: StudentService, private dialogRef: MatDialogRef<AddPortfolioModalComponent>) {
  }

  ngOnInit() {
    this.addDocumentForm = new FormGroup({
      'fileCategory': new FormControl(null, [
        Validators.required,
      ]),
      'fileDescription': new FormControl(null, [
        Validators.required,
      ])
    });
    this.onChanges();
    this.portfolioService.getPortfolioCategories(this.userService.currentUser.Id).subscribe(res => {
      this.portfolioCategories = res;
    });
  }

  saveClick() {
    if (this.checkInputs()) {
      let fileSize = window.atob(this.addFile.fileString).length;
      let sizeUnit = 'bytes';
      if (fileSize > 1024) {
        fileSize = this.roundToTwo(fileSize / 1024);
        sizeUnit = 'KB';
      }
      if (fileSize > 1000) {
        fileSize = this.roundToTwo(fileSize / 1024);
        sizeUnit = 'MB';
      }
      // build of the portfolio object
      const portfolio: Portfolio = new Portfolio();
      portfolio.CategoryID = this.category;
      portfolio.StudentID = this.studentService.selectedStudent.Id;
      portfolio.Name = this.addFile.fileName;
      portfolio.Description = this.description;
      portfolio.FileBase64 = this.addFile.fileString;
      portfolio.FilePath = this.addFile.fileName;
      portfolio.AYIdentifier = this.yearService.student360Year.AYIdentifier;
      portfolio.AddedBy = this.userService.currentUser.MemberId.toString();
      portfolio.Size = fileSize;
      portfolio.SizeUnit = sizeUnit;
      // save to the database
      this.portfolioService.saveStudentPortfolio(portfolio).subscribe(res => {
        if (res.ok) {
          // Close the dialog
          this.dialogRef.close('Success');
        }
      });
    }
  }

  onChanges(): void {
    this.addDocumentForm.valueChanges.subscribe(val => {
      this.category = val['fileCategory'];
      this.description = val['fileDescription'];
      // check new Category
      if (this.addDocumentForm.controls.fileCategory.invalid) {
        if (this.addDocumentForm.controls.fileCategory.errors.hasOwnProperty('required')) {
          this.fileCategoryErrorMessage = 'Category is required';
        }
      }
      // Check Description
      if (this.addDocumentForm.controls.fileDescription.invalid) {
        if (this.addDocumentForm.controls.fileDescription.errors.hasOwnProperty('required')) {
          this.fileDescriptionErrorMessage = 'Description is required';
        }
      }
    });
  }

  checkInputs(): boolean {
    let isValid = true;
    if (this.fileCategory.invalid) {
      this.fileCategory.markAsTouched();
      this.fileCategory.markAsDirty();
      isValid = false;
    }
    if (this.fileDescription.invalid) {
      this.fileDescription.markAsTouched();
      this.fileDescription.markAsDirty();
      isValid = false;
    }
    if (!this.addFile.hasOwnProperty('fileName')) {
      this.fileError = true;
      isValid = false;
    } else {
      if (this.addFile.fileName == null) {
        this.fileError = true;
        isValid = false;
      } else {
        this.fileError = false;
      }
    }
    return isValid;
  }

  get fileCategory() {
    return this.addDocumentForm.get('fileCategory');
  }

  get fileDescription() {
    return this.addDocumentForm.get('fileDescription');
  }

  addFileChanges(event) {
    // check if a file has been selected
    if (this.addFile.hasOwnProperty('fileName')) {
      this.fileError = false;
    }
  }

  roundToTwo(num) {
    return +(Math.round(Number(num + 'e+2')) + 'e-2');
  }

  closeClick() {
    this.dialogRef.close();
  }
}
